import type { AnyGameModule, SceneModule } from '@efira/game-sdk';

/**
 * Реестр сцен: идентификатор -> ленивый импорт.
 *
 * ЛЕНИВЫЙ - ключевое слово. Чанк сцены не входит в граф точки входа и не
 * грузится при старте overlay: бюджет первой загрузки складывается из
 * базового кода плюс ОДНА сцена, а не из всех сразу
 * (docs/ARCHITECTURE.md, раздел 6). Проверяется структурными воротами
 * (scripts/check-overlay-budget.mjs), а не соглашением.
 *
 * Модуль отдаёт либо игру (`game`), либо сцену (`scene`). Различие в форме
 * модуля, а не во флаге реестра: флаг можно забыть проставить, форму - нет.
 *
 * Список игр - `@efira/games`, единственный источник (ARCHITECTURE 2.2).
 * Здесь лежат только загрузчики: реестр знает, ЧТО существует, а этот файл -
 * КАК это загрузить, и смешивать их нельзя, потому что первое читают сервер,
 * лендинг и dashboard, а второе - только overlay.
 */
export const SCENE_LOADERS: Record<string, () => Promise<SceneModule | AnyGameModule>> = {
  goryacho: () => import('@efira/game-goryacho/scene').then((m) => ({ game: m.game })),
  stenka: () => import('@efira/game-stenka/scene').then((m) => ({ game: m.game })),
  znatok: () => import('@efira/game-znatok/scene').then((m) => ({ game: m.game })),
  ugadayka: () => import('@efira/game-ugadayka/scene').then((m) => ({ game: m.game })),
  zaezd: () => import('@efira/game-zaezd/scene').then((m) => ({ game: m.game })),
  'snezhny-kom': () => import('@efira/game-snezhny-kom/scene').then((m) => ({ game: m.game })),
  peredel: () => import('@efira/game-peredel/scene').then((m) => ({ game: m.game })),
  arena: () => import('@efira/game-arena/scene').then((m) => ({ game: m.game })),
  duel: () => import('@efira/game-duel/scene').then((m) => ({ game: m.game })),
  razgon: () => import('@efira/game-razgon/scene').then((m) => ({ game: m.game })),

  // Фикстуры контракта сцены. Не игры - и это видно по именам.
  pulse: () => import('@efira/test-scenes/pulse').then((m) => ({ scene: m.scene })),
  ticker: () => import('@efira/test-scenes/ticker').then((m) => ({ scene: m.scene })),
};

export function isKnownScene(id: string | null): id is string {
  return id !== null && Object.hasOwn(SCENE_LOADERS, id);
}
